<template>
<div class="chapter">
<div class="inner_page">
<h2 id="sigil_toc_id_4" title="Dedication"></h2>
<p class="center">for joella</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// dedication.vue?129290a6